import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const buzzwordsApi = {
  /**
   * Add a buzzword to a topic.
   * Buzzwords are returned inline with topics — no separate list endpoint.
   * @param {number} userId
   * @param {number} topicId
   * @param {{ buzzword: string }} body
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  add: (userId, topicId, body, config) =>
    mod.post(
      `/subscribers/${userId}/topics/${topicId}/buzzwords/`,
      { topicId, ...body },
      config,
    ),

  /**
   * @param {number} userId
   * @param {number} topicId
   * @param {number} buzzwordId
   * @param {import('axios').AxiosRequestConfig} [config]
   */
  remove: (userId, topicId, buzzwordId, config) =>
    mod.delete(
      `/subscribers/${userId}/topics/${topicId}/buzzwords/${buzzwordId}`,
      config,
    ),
};
